import React from 'react';
import styles from './Input.module.scss';

const Input = ({ field, handleKey, label, error, ...props }) => {
  return (
    <div className={styles.inputContainer}>
      {label && (
        <label className={styles.label}>
          {label}
        </label>
      )}
      <input 
        {...field} 
        {...props}
        onKeyDown={handleKey} 
        className={`${styles.input} ${error ? styles.inputError : ''}`} />
      <div className={`${styles.errorMessage} ${error ? styles.errorVisible : styles.errorHidden}`}>
        {error || '\u00A0'}
      </div>
    </div>
  );
};

export default Input;